import { FormGroup } from "@angular/forms";
import { FieldDefinition } from "../../../../sections/createSendProductReport/message/fieldDefinition";
import { FormlyView } from "../FormlyView";
import { FormlyFieldConfig } from "@ngx-formly/core";

export class SubstanceAttachmentFields extends FormlyView {

        constructor(
            fieldDefinition: FieldDefinition,
            operationtype: any
        ) {
    
            let attachmentFields: FormlyFieldConfig[]= [...fieldDefinition.psiattachmentFields];
            if (operationtype && (operationtype===1)){
                attachmentFields[1].fieldGroup![0].props!["required"]=true;
            }
            super(new FormGroup({}), 
                attachmentFields, {});
    
        }


}
